import { useSafeLocalStorage } from './useSafeLocalStorage.js'

export const useOnboarded = (): [boolean, (bool: boolean) => void] => {
  return useSafeLocalStorage<boolean>(
    '2026onboarded',
    false,
    (v) => typeof v === 'boolean',
  )
}
